import type { SchemaToType } from '@main/schema-utils';
import { mkType } from '@main/schema-utils';

export const AssessmentFormTemplatePreview = mkType({
  name: 'AssessmentFormTemplatePreview',
  comment:
    'Very limited subset of fields necessary to identify an assessment form template in the UI',
  fields: {
    id: {
      comment: 'The id of the assessment form template',
      type: 'id',
      modelName: 'assessmentFormTemplate',
    },
    title: {
      comment: 'The title of the assessment form template',
      type: 'string',
    },
  },
});

/** Override type */
export type AssessmentFormTemplatePreview = SchemaToType<
  typeof AssessmentFormTemplatePreview
>;
